<div class="modal" data-iframe-size>
  <img [src]="uiValues.iconUrl" class="icon" />
  <h4 class="title">
    {{ uiValues.titleKey | translate:unchangedPlaceholdersCount }}
  </h4>

  <mat-dialog-content>
    <div class="content">
      {{ uiValues.messageKey |
         translate:unchangedPlaceholdersCount:{'text':textContent} }}
    </div>
  </mat-dialog-content>

  <dialog-buttons [buttons]="uiValues.buttons"></dialog-buttons>
</div>



// WEBPACK FOOTER //
// ./src/app/dialogs/unchanged-placeholders-dialog/unchanged-placeholders-dialog.component.html